var map = {
	"./a2.png": "0QLa",
	"./a2en.png": "jxnM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bGrj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet ^\.\/a2.*\.png$
// module id = bGrj
// module chunks = 0